import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import 'src/stylesheets/sessions.scss';

const PublicLayout = ({ children }) => {
  return (
    <div>
      <Grid fluid className="login-form">
        {children}
      </Grid>
      <Row>
        <Col xs={12} sm={12} md={12} lg={12} className="footer">
          <p>Copyright &copy; BROADBAND TOWER, INC. ALL RIGHTS RESERVED.</p>
        </Col>
      </Row>
    </div>
  );
};

export default PublicLayout;
